import { render } from "./passwordResetEmail.vue?vue&type=template&id=283c97b7"
import script from "./passwordResetEmail.vue?vue&type=script&lang=js"
export * from "./passwordResetEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__